<template>
	<div>
		<h1>演示/调测</h1>
		<h3>两段式加载反馈</h3>
		<p>
			<el-table :data="tableData" style="width: 100%;" id="test_table">
				<el-table-column prop="date" label="日期" width="180"></el-table-column>
				<el-table-column prop="name" label="姓名" width="180"></el-table-column>
				<el-table-column prop="address" label="地址"></el-table-column>
			</el-table>
			<el-button @click="quickRequest">快请求</el-button>
			<el-button @click="lightRequest">中请求</el-button>
			<el-button @click="heavyRequest">慢请求</el-button>
			<el-button @click="failedQuickRequest">失败快请求</el-button>
			<el-button @click="failedLightRequest">失败中请求</el-button>
			<el-button @click="failedHeavyRequest">失败慢请求</el-button>
			<el-button @click="blockQuickRequest">局部快请求</el-button>
			<el-button @click="blockSlowRequest">局部中请求</el-button>
			<el-button @click="blockHeavyRequest">局部慢请求</el-button>
			<el-button @click="blockFailedRequest">局部失败请求</el-button>
		</p>

		<h3>API</h3>
		<el-form :inline="true" class="apiform">
			<el-form-item label="接口">
				<el-cascader
					expand-trigger="hover"
					:options="apiOptions"
					v-model="selectedApi"
					@change="apiSelected"
				></el-cascader>
			</el-form-item>
			<el-form-item label="载入温馨提示">
				<el-switch v-model="apiLoadingToBlock" active-text="组件" inactive-text="全屏"></el-switch>
			</el-form-item>
			<el-form-item label="参数">
				<el-input v-model="apiArgs" placeholder="请填入参数，逗号隔开"></el-input>
			</el-form-item>
			<el-form-item label="过滤">
				<el-input v-model="apiFilterBy" placeholder="过滤字段名:值"></el-input>
			</el-form-item>
			<el-form-item label="排序">
				<el-input v-model="apiSortBy" placeholder="排序字段名[:asc/desc]"></el-input>
			</el-form-item>
			<el-form-item label="分页">
				<el-input v-model="apiPaginate" placeholder="页码[,每页记录数]"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="apiCall">调用</el-button>
			</el-form-item>
		</el-form>
		<json-viewer :value="apiResp" :expand-depth="3" id="json_viewer"></json-viewer>

		<h3>文件上传</h3>

		<h5>默认</h5>
		<oss-uploader></oss-uploader>

		<h5>默认</h5>
		<oss-uploader :on-change="refreshUpFileList" :on-remove="refreshUpFileList">
			<div style="border: 1px solid black;">修改触发区域HTML，点我上传</div>
			<template v-slot:tip>
				<p>说明文字，不引发上传</p>
			</template>
		</oss-uploader>

		<h5>照片墙</h5>
		<oss-uploader
			list-type="picture-card"
			multiple
			:limit="50"
			accept="image/*"
			:on-change="refreshUpFileList"
			:on-remove="refreshUpFileList"
		>
			<i class="el-icon-plus"></i>
		</oss-uploader>

		<el-table :data="uploadFiles" stripe style="width: 100%;">
			<el-table-column prop="name" label="文件名" width="180"></el-table-column>
			<el-table-column prop="key" label="Key" width="180"></el-table-column>
			<el-table-column prop="type" label="类型"></el-table-column>
		</el-table>
	</div>
</template>

<script>
import { reqfb } from '@/components/RequestFeedback'
import JsonViewer from 'vue-json-viewer'

let seq = 1

function successRequest(processTime, seq) {
	reqfb.start()
	setTimeout(() => {
		reqfb.finish()
		this.$message({
			message: '成功! 序号：' + seq,
			type: 'success'
		})
	}, processTime)
}

function successBlockRequest(processTime, seq) {
	reqfb.start('#test_table')
	setTimeout(() => {
		reqfb.finish('#test_table')
		this.$message({
			message: '成功! 序号：' + seq,
			type: 'success'
		})
	}, processTime)
}

function failRequest(processTime, seq) {
	reqfb.start()
	setTimeout(() => {
		reqfb.fail()
		this.$message({
			message: '失败鸟! 序号：' + seq,
			type: 'error'
		})
	}, processTime)
}

function failBlockRequest(processTime, seq) {
	reqfb.start('#test_table')
	setTimeout(() => {
		reqfb.fail('#test_table')
		this.$message({
			message: '失败鸟! 序号：' + seq,
			type: 'error'
		})
	}, processTime)
}

export default {
	components: {
		'json-viewer': JsonViewer
	},
	data() {
		return {
			uploadFiles: [],
			tableData: [
				{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				},
				{
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				},
				{
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}
			],
			apiOptions: [
				{
					value: 'account',
					label: '账号',
					children: [
						{ label: '登录', value: ['login', 'pa1', '123456'] },
						{ label: '登出', value: ['logout'] },
						{ label: '信息', value: ['info', 0] }
					]
				},
				{
					value: 'ad',
					label: '广告',
					children: [
						{ label: '列表', value: ['list'] },
						{ label: '单条详情', value: ['show', 1] },
						{
							label: '创建',
							value: ['create', 1, '/images/faker.png', 'This is the text', 'http://www.baidu.com', 0, 99]
						},
						{
							label: '更新',
							value: ['update', 1, 1, '/images/faker.png', 'This is the text', 'http://www.baidu.com', 0, 99]
						},
						{ label: '删除', value: ['delete', 1] }
					]
				},
				{
					value: 'post',
					label: '帖子文章',
					children: [
						{ label: '列表', value: ['list'] },
						{ label: '单条详情', value: ['show', 1] },
						{
							label: '创建',
							value: ['create', '标题', '内容啊', 0]
						},
						{
							label: '更新',
							value: ['update', 1, 'create', '标题', '内容啊', 0]
						},
						{ label: '删除', value: ['delete', 1] }
					]
				},
				{
					value: 'public_notice',
					label: '公告',
					children: [
						{ label: '列表全网公告', value: ['listPublic'] },
						{ label: '列表用户可读公告', value: ['listUserReadables', 0] },
						{ label: '单条详情', value: ['show', 1] }
					]
				},
				{
					value: 'question_set',
					label: '题库',
					children: [
						{ label: '列表', value: ['list'] },
						{ label: '单条详情', value: ['show', 1] },
						{
							label: '创建',
							value: ['create', '题库名称', 3, true]
						},
						{
							label: '更新',
							value: ['update', 1, '题库名称', 3, true]
						},
						{ label: '删除', value: ['delete', 1] },
						{ label: '某题库下 - 列表题目', value: ['list_questions_in', 1] },
						{
							label: '某题库下 - 单条题目详情',
							value: ['show_question_in', 1, 1]
						},
						{
							label: '某题库下 - 创建题目',
							value: [
								'create_question_in',
								1,
								1,
								0,
								'这里是题干，题目的主体部分',
								['选项A', '选项B', '选项C', '选项D'],
								1,
								['media1', 'media2'],
								10,
								0,
								'解释',
								'知识点'
							]
						},
						{
							label: '某题库下 - 更新题目',
							value: [
								'update_question_in',
								1,
								1,
								1,
								0,
								'这里是题干，题目的主体部分',
								['选项A', '选项B', '选项C', '选项D'],
								1,
								['media1', 'media2'],
								10,
								0,
								'解释',
								'知识点'
							]
						},
						{
							label: '某题库下 - 删除题目',
							value: ['delete_question_in', 1, 1]
						}
					]
				},
				{
					value: 'test',
					label: '考试测试',
					children: [
						{ label: '列表', value: ['list'] },
						{ label: '列表属于学生的 ', value: ['list_by_user'] },
						{ label: '单条详情', value: ['show', 1] },
						{
							label: '创建',
							value: ['create', 1, [], [], '测试名字', 1, null, null, 0, 1, 1, 0]
						},
						{
							label: '更新',
							value: ['update', 1, 1, [], [], '测试名字', 1, null, null, 0, 1, 1, 0]
						},
						{
							label: '学生看测试详情',
							value: ['show_by_user', 1, 1]
						},
						{ label: '学生答卷', value: ['answer_by_user', 1, 1, 1, 3] },
						{
							label: '删除',
							value: ['delete', 1]
						}
					]
				}
			],
			selectedApi: [],
			apiResp: '请在上面选择API并调用，这里查看结果',
			apiLoadingToBlock: true,
			apiArgs: '',
			apiFilterBy: '',
			apiSortBy: '',
			apiPaginate: ''
		}
	},
	methods: {
		quickRequest() {
			successRequest.call(this, 200, seq++)
		},
		lightRequest() {
			successRequest.call(this, 3000, seq++)
		},
		heavyRequest() {
			successRequest.call(this, 10000, seq++)
		},
		failedQuickRequest() {
			failRequest.call(this, 200, seq++)
		},
		failedLightRequest() {
			failRequest.call(this, 3000, seq++)
		},
		failedHeavyRequest() {
			failRequest.call(this, 10000, seq++)
		},
		blockQuickRequest() {
			successBlockRequest.call(this, 200, seq++)
		},
		blockSlowRequest() {
			successBlockRequest.call(this, 3000, seq++)
		},
		blockHeavyRequest() {
			successBlockRequest.call(this, 10000, seq++)
		},
		blockFailedRequest() {
			failBlockRequest.call(this, 3000, seq++)
		},
		apiSelected() {
			let args = new Array()
			if (Array.isArray(this.selectedApi[1])) {
				args = this.selectedApi[1].slice(1)
			}

			let flattenArr = new Array()
			args.forEach(el => {
				if (Array.isArray(el)) {
					flattenArr.push(encodeURIComponent(JSON.stringify(el)))
				} else {
					flattenArr.push(el)
				}
			})
			this.apiArgs = flattenArr.join(',')
		},
		async apiCall() {
			let category = this.selectedApi[0]
			let action = null
			let args = null
			if (Array.isArray(this.selectedApi[1])) {
				action = this.selectedApi[1][0]
			} else {
				action = this.selectedApi[1]
			}

			args = this.apiArgs.split(',')
			for (let i = 0; i < args.length; i++) {
				args[i] = args[i].trim()
				if (args[i].startsWith('%5B')) {
					args[i] = JSON.parse(decodeURIComponent(args[i]))
				}
			}
			args = args.filter(el => {
				return el != ''
			})

			let apiClient = null
			if (this.apiLoadingToBlock) {
				// 不用走默认了，自己来
				apiClient = this.$api.newInstance({
					loading_feedback: '#json_viewer'
				})
			} else {
				apiClient = this.$api
			}

			let listOptions = {}
			if (this.apiFilterBy.length > 0) {
				let fbArr = this.apiFilterBy.split(':')
				if (fbArr.length == 2) {
					listOptions.filterBy = {}
					listOptions.filterBy[fbArr[0]] = fbArr[1]
				}
			}

			if (this.apiSortBy.length > 0) {
				let arr = this.apiSortBy.split(':')
				if (arr.length == 2) {
					listOptions.sortBy = {}
					listOptions.sortBy[arr[0]] = arr[1]
				} else if (arr.length == 1) {
					listOptions.sortBy = {}
					listOptions.sortBy[arr[0]] = 'asc'
				}
			}

			if (this.apiPaginate.length > 0) {
				let arr = this.apiPaginate.split(',')
				if (arr.length == 2) {
					listOptions.paginate = {}
					listOptions.paginate.page = arr[0]
					listOptions.paginate.size = arr[1]
				} else if (arr.length == 1) {
					listOptions.paginate = {}
					listOptions.paginate.page = arr[0]
				}
			}

			if (Object.keys(listOptions).length > 0) {
				args.push(listOptions)
			}

			let res = await apiClient[category][action].apply(this.$api, args)
			this.apiResp = res
		},
		refreshUpFileList(file, fileList) {
			this.uploadFiles = fileList.map(file => {
				return {
					name: file.name,
					key: file.raw.key,
					type: file.raw.type
				}
			})
		}
	}
}
</script>

<style>
.apiform .el-form-item {
	margin-right: 10px;
	padding-right: 10px;
	border-right: 1px solid #cccccc;
}
</style>
